module.exports = __webpack_public_path__ + "static/paris-009.thumb-fcca1726d68981b21a8947d782fa8ae1.jpg";